<template>
  <div class="version-file">
    <div class="online">
      <h4>线上版本</h4>
      <table class="bk-table has-table-bordered">
        <colgroup>
          <col style="width:164px">
          <col style="width:164px">
          <col style="width:186px">
          <col style="width:315px;">
        </colgroup>
        <tbody>
          <template v-for="(item,index) in versionList">
            <tr v-if="item.status === 0">
              <template>
                <td>版本号：{{item.name}}</td>
                <td>文件大小：{{item.file_size}}</td>
                <td>更新时间：{{item.update_time}}</td>
              </template>
              <td>
                <div class="downloadbox">
                  <a href="javascript:" class="bk-text-button" @click="openPopup">更换线上版本</a>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <div class="account-right-item attention" v-if="!isLoading" @click="slideDown">
      <button class="bk-button bk-primary" title="更新版本" @click="createVersion">
        <i class="bk-icon icon-upload"></i>
        <span>更新版本</span>
      </button>
      <table class="bk-table has-table-bordered" v-show="!isUpdate">
        <colgroup>
          <col style="width:164px">
          <col style="width:164px">
          <col style="width:186px">
          <col style="width:108px;">
          <col style="width:168px">
          <col style="width:40px;">
        </colgroup>
        <tbody>
          <template v-for="(item,index) in versionList">
            <tr>
              <td>版本号：{{item.name}} <span class="new" v-if="index === newIndex">New</span></td>
              <td>文件大小：{{item.file_size}}</td>
              <td>更新时间：{{item.update_time}}</td>
              <td>
                <span v-if="item.status === 0" class="status onlineIcon" style="color:#5bd18b">
                  <i class="fa fa-check-circle"></i>线上版本
                </span>
                <span v-if="item.status === 1" class="status default">正常</span>
                <span v-if="item.status === 2" class="status info">审核中</span>
                <span v-if="item.status === 4" class="status danger">异常</span>
                <span v-if="item.status === 3" class="status fail">未通过</span>
              </td>
              <td>
                <i :class="['bk-icon', 'icon-download',{'icon-checking':item.status > 1 }]" @click.stop.prevent="download(item,index)">
                  <span class="tips">版本下载</span>
                  <span class="download-box" v-if="index === curDownloadIndex">
                    <span class="download-content sss" @click="freeDownload(item)">普通版</span>
                    <span v-show="sysType > 0" class="download-content" @click="customDownload(item,index)">企业定制版</span>
                  </span>
                </i>
                <i :class="['bk-icon', 'icon-delete',{'icon-active':item.version_id === changeVersionId }]" @click.stop.prevent="secondaryPopup(item, index)">
                  <span class="tips">删除该版本</span>
                </i>
              </td>
              <td @click.stop.prevent='slideUp(item, index)' :class="['last', {'gruy': index === curVersionIndex}]">
                <i :class="['bk-icon icon-angle-down',{'icon-angle-up': index === curVersionIndex}]">
                  <span class="tips">查看版本详情</span>
                </i>
              </td>
            </tr>


            <tr class="bk-table-tr" v-if="index === curVersionIndex" @click.stop.prevent="slideDownPrevent(index)">
              <td colspan="6" style="padding: 0;">
                <div class="bk-table-list left">
                  <div class="bk-list-title">
                    文件列表
                  </div>
                  <ul>
                    <li class="bk-list-li">
                      <i class="bk-icon icon-file-zip"></i>
                      <div class="bk-list-content">
                        <span class="name">{{item.file_list[0]}}</span>
                        <span class="capacity">{{item.file_size}}</span>

                        <span class="bk-load" v-if="loadStatus === '1' && sindex === curFileIndex">
                          <span class="loading"></span>
                        </span>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="bk-table-list right">
                  <div class="bk-list-title">
                    更新内容
                  </div>
                  <p class="bk-list-title-para">{{item.change_log}}</p>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <form class="bk-form form-version" v-show="isUpdate">
        <div class="bk-form-item is-required">
          <label class="bk-label">版本号：</label>
          <div class="bk-form-content">
            <input type="text" v-model="formData.version" @input="checkValidate" class="bk-form-input" style="width: 320px" placeholder="请选择">
            <span class="tips version" v-if="formData.isShow">{{formData.tips}}</span>
          </div>
        </div>
        <div class="bk-form-item is-required">
          <label class="bk-label">版本文件：</label>
          <div class="bk-form-content">
            <div class="bk-form-textarea bk-form-upload" style="width: 705px">
              <p>
                <i class="bk-icon icon-upload"></i>
                <a href="javascript:">点击上传</a>
              </p>
              <input type="file" value="" name="uploadFile" @change="handleFile" class="upload-file" maxRequestLength="10240" />
            </div>
          </div>
        </div>
        <div class="bk-form-item">
          <label class="bk-label">&nbsp;</label>
          <div class="bk-form-content" v-show="ableToUpload">
            <div class="bk-upload-ul" v-if="formData.file.length !== 0 ">
              <div class="bk-list-li">
                <i class="bk-icon icon-file-zip"></i>
                <div class="bk-list-content">
                  <span class="name">{{formData.file.name}}</span>
                  <i class="bk-icon icon-close" @click="deleteFile()" v-if="loadingStatus === 'start'"></i>
                  <i class="bk-icon icon-check-1" v-else></i>
                  <span class="bk-load" v-show="loadingStatus === 'start'">
                    <span :class="[{'loading': loadingStatus === 'start'}, {'totalLoading': loadingStatus === 'complete'}]"></span>
                    <span></span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bk-form-item is-required">
          <label class="bk-label">更新内容：</label>
          <div class="bk-form-content">
            <textarea name="" id="" v-model="formData.updataMsg" class="bk-form-textarea" placeholder="请输入产品的详细介绍" style="width: 705px"></textarea>
          </div>
        </div>
        <div class="bk-form-item bk-form-action">
          <label class="bk-label">&nbsp;</label>
          <div class="bk-form-content">
            <a :class="['bk-button', 'bk-primary',{'is-loading':saveFlag === false}]" id="submit" @click="saveUpdate" title="保存">
              <span>保存</span>
            </a>
            <a class="bk-button" title="取消" @click="cancelSave">
              <span>取消</span>
            </a>
          </div>
        </div>
      </form>
    </div>
    <!-- 加载 -->
    <loading :ifLoadingStart="isLoading" class="loading"></loading>

    <!-- 删除确定弹出框 -->
    <div class="pop-wrapper" v-if="showPop">
      <div class="pop-box">
        <div class="pop-header clearfix">
          <a href="javascript:;" class="fr" @click="showPop=false">
            <img src="../../../images/common/close.png" alt="">
          </a>
        </div>
        <div class="pop-body">
          确定删除该版本？
        </div>
        <div class="pop-footer">
          <a href="javascript:;" class="yes" @click="confirmDelete()">确定</a>
          <a href="javascript:;" class="no" @click="showPop=false">取消</a>
        </div>
      </div>
    </div>
    <!-- 更换版本弹窗组件 -->
    <popup :title="popup.title" class="isSelect" :show="popup.isShow" @close="closePopup">
      <div slot="popup-body" :is="currentView" @close="closePopup" :versionList='changeVersionList' @changeVersion="toChangeId"
        style="height: 100%;">
      </div>
    </popup>
    <!-- 下载弹窗 -->
    <popup :show="downPopupShow" class="public" @close="closeDownloadPopup">
      <div slot="popup-body">
        <!-- 企业定制版 -->
        <div class="public-content" v-if="downloadStatus==0">
          <div class="round">
            <img src="../../../images/application_detail/pops-download.png" alt="" />
          </div>
          <p class="text">正在为您自动下载“{{appName}}”版本“{{curVersionName}}”</p>
          <p class="tips">如果您的浏览器不支持自动下载，请手动下载该作品</p>
          <a href="javascript:;" class="confirm-button"  @click.stop.prevent="enterpriseDownload">下载地址</a>
        </div>
        <!-- 普通版 -->
        <div class="public-content" v-if="downloadStatus==5">
          <div class="round">
            <img src="../../../images/application_detail/pops-download.png" alt="" />
          </div>
          <p class="text">正在为您自动下载“{{appName}}”版本“{{curVersionName}}”</p>
          <p class="tips">如果您的浏览器不支持自动下载，请手动下载该作品</p>
          <a href="javascript:;" class="confirm-button" @click.stop.prevent="commonDownload">下载地址</a>
        </div>
        <!-- 企业选择 -->
        <div class="public-content bank" v-if="downloadStatus == 1">
          <version-file-download
            ref="versionFileDownload"
            :enterprise-list="appList"
            :user-cert-needed.sync="userCertNeeded"
            @confirm="selectDownloadType"
            @cancel="cancelDownloadSelect">
          </version-file-download>
        </div>
        <!-- 调用后台打包接口前报错 -->
        <div class="public-content warning" v-if="downloadStatus==3">
          <div class="round">
            <i>
              <img src="../../../images/application_detail/pops-waring.png" alt="" />
            </i>
          </div>
          <p class="text" style="margin-top:10px;">文件编译失败，请重试</p>
          <p class="tips">错误码：{{errorCode}}</p>
          <a href="javascript:;" class="confirm-button againPack" @click="doAgainPack">重新打包</a>
        </div>
        <!-- 后台返回错误 -->
        <div class="public-content warning" v-if="downloadStatus==4">
          <div class="round">
            <i>
              <img src="../../../images/application_detail/pops-waring.png" alt="" />
            </i>
          </div>
          <p class="text" style="margin:30px 0;">文件编译失败，请联系客服解决</p>
          <!-- <p class="tips">错误码：{{errorCode}}</p> -->
          <a href="javascript:;" class="confirm-button service">联系客服</a>
        </div>

        <!-- 开始打包 -->
        <div class="public-content" v-if="downloadStatus==2">
          <div class="round tempo">
            <span class="number">{{ packagePercent }}</span>%</div>
          <p class="text">正在为您编译文件准备APP包，请稍等片刻...</p>
          <div class="tips">
            <p>初次下载定制包需要验证企业信息</p>
            <p>打包过程可能需要几秒到几十秒的时间</p>
          </div>
        </div>
      </div>
      <div slot="popup-footer" :show="false">
      </div>
    </popup>
    <!-- 企业版下载选择App弹出框 -->

    <v-alert :options="options"></v-alert>
  </div>

</template>

<script type="text/javascript">
  import popup from './../../popup.vue'
  import change_version from './change_version.vue'
  import versionFileDownload from './version_file_download.vue'
  import vAlert from './../../alert.vue'
  import loading from '../../loading.vue' //导入加载子组件
  export default {
    data() {
      return {
        saveFlag: true, //提交按钮
        curVersionId:'', //普通版下载
        errorCode: 134, //后台返回打包出错的状态码
        isLoading: true,
        versionWithNew: '', //带new标志的
        packagePercent: 0,
        changeVersionList: [], //更换线上版本的下拉列表
        packStatus: '', //企业版下载前打包状态
        sysType: -1, //产品类型
        versionState: 1,
        popup: {
          isShow: false,
          title: ''
        },
        appName: '', //要下载的当前产品名字
        curVersionName: '', //要下载的当前版本号
        showPop: false,
        downloadStatus: -1,
        curVersionId: '', //线上版本
        changeVersionId: '', //更新线上版本的下拉列表   
        downloadUrl: "", // 下载链接
        downPopupShow: false, // 下载弹窗状态
        formData: {
          version: '',
          file: {},
          fileId: [],
          updataMsg: '',
          isShow: false,
          tips: ''
        },
        ableToUpload: false, // 是否允许上传文件
        currentView: '', //当前view
        loadStatus: '0', //普通版or企业版
        curVersionIndex: -1,
        curFileIndex: -1,
        curDownloadIndex: -1, // 下载icon的当前索引值
        curDownVersionId: '', //当前下载的版本ID
        versionFileDownloadConfig: {}, // 下载应用版本配置项
        userCertNeeded: false, // 用户代号是否需要上传证书
        onlineVersion: {
          name: '', //版本号
          version_id: '', //版本ID
          file_size: '', //文件大小
          update_time: '', //更新时间
          change_log: ''
        },
        versionList: [],
        appList: [],
        fileList: [],
        isUpdate: false,
        options: {
          msgText: "",
          msgIsSuccess: false
        },
        loadingStatus: ''
      }
    },
    computed: {
      newIndex () {
        if (this.versionList.length) {
          for (let i = 0; i < this.versionList.length; i++) {
            if (this.versionList[i].status === 0 || this.versionList[i].status === 1) {
              return i
            }
          }
        } else {
          return -1
        }
      }
    },
    methods: {
      cancelSave() {
        this.formData.version = '';
        this.formData.file = {};
        this.formData.tips = '';
        this.formData.updataMsg = '';
        this.ableToUpload = false;
        this.isUpdate = false;
      },
      /*
       ** 点击重新打包
       */
      doAgainPack() {
        this.beginPack();
      },
      /*
       ** 点击删除按钮
       */
      secondaryPopup(item, index) {
        if (item.version_id === this.changeVersionId) {

          return
        }
        this.showPop = true;
        this.todeleteId = item.version_id;
      },
      /*
       ** 点击删除按钮时，点击确定删除
       */
      confirmDelete() {
        this.deleteVersionFile();
        this.showPop = false;
        this.getVersionFile();
      },
      /*
       ** 更换线上版本,data为子组件传过来接下来更新为的版本id
       */
      toChangeId(data) {
        this.changeVersionId = data;
        const app_id = this.$route.params.wid;
        let params = {
          keyword: 'change_version',
          version_id: this.changeVersionId
        }
        axios.post(myUrl + `core/product/update/${app_id}/`, qs.stringify(params)).then((res) => {
          this.getVersionFile();
          this.options = {
            msgIsSuccess: true,
            msgText: "更换线上版本成功！"
          }
        }, reject => {
          this.options = {
            msgText: reject.message,
            msgIsSuccess: false
          }
        })
      },
      /*
       ** 添加新的版本时，表单验证
       */
      checkValidate() {
        let formData = this.formData;
        if (!(/^\d+(\.\d+){0,2}$/).test(this.formData.version)) {
          formData.isShow = true;
          formData.tips = "请输入合法版本号（2位式：1.5 / 3位式：1.5.0）";
          return false;
        } else {
          formData.isShow = false;
          formData.tips = "";
          return true;
        }
      },
      /*
       ** 删除上传文件
       */
      deleteFile() {
        this.files = {};
        this.ableToUpload = false;
      },
      /*
       ** 打开更换线上版本的弹窗
       */
      openPopup() {
        const app_id = this.$route.params.wid;
        this.popup.isShow = true;
        this.currentView = 'change_version';
       
      },
      /*
       ** 关闭弹窗
       */
      createVersion() {
        this.isUpdate = true;
      },
      closePopup() {
        this.currentView = '';
        this.popup.isShow = false;
      },
      closeDownloadPopup() {
        this.downPopupShow = false;
        if (this.$refs.versionFileDownload) {
          this.$refs.versionFileDownload.reset()
        }
      },
      /*
       ** 点击空白区域收起所有下拉框
       */
      slideDown() {
        this.curVersionIndex = -1;
        this.curDownloadIndex = -1;
      },
      handleDocumentClick(e) {
        if (!this.$el.contains(e.target)) {
          this.curDownloadIndex = -1;
          } 
      },
      /*
       ** 点击下拉框保持展开状态
       */
      slideDownPrevent(index) {
        this.curVersionIndex = index;
      },
      /*
       ** 展开下拉
       */
      slideUp(item, index) {
        if (this.curVersionIndex === index) {
          this.curVersionIndex = -1;
        } else {
          this.curVersionIndex = index;
        }
      },
      download(item, index) {
        //审核状态不可以下载
        if (item.status > 1) {
          return
        }
        this.curDownloadIndex = index;
      },
      commonDownload() {
        this.curDownloadIndex = -1;
        // this.curVersionName = item.name;
        this.downloadStatus = 0;
        let versionId = this.curVersionId;
        let app_id = this.$route.params.wid;
        axios.get(myUrl + `core/product/download/${app_id}/${versionId}/`).then((res) => {
          if (res.data.result) {
            this.downPopupShow = true;
            this.downloadStatus = 5;
            this.options = {
              msgIsSuccess: true,
              msgText: res.data.message
            }
            setTimeout(() => {
              window.location.href = res.data.data;
            }, 300)
          } else {
            this.downPopupShow = true;
            this.downloadStatus = 4;
            this.options = {
              msgIsSuccess: false,
              msgText: res.data.message
            }
          }
        })
      },
      /*
       ** 点击下载，选择普通版下载
       */
      freeDownload(item) {
        this.curDownloadIndex = -1;
        this.curVersionName = item.name;
        this.downloadStatus = 0;
        this.curVersionId = item.version_id;
        let versionId  = this.curVersionId;
        let app_id = this.$route.params.wid;
        axios.get(myUrl + `core/product/download/${app_id}/${versionId}/`).then((res) => {
          if (res.data.result) {
            this.downPopupShow = true;
            this.downloadStatus = 5;
            this.options = {
              msgIsSuccess: true,
              msgText: res.data.message
            }
            setTimeout(() => {
              window.location.href = res.data.data;
            }, 300)
          } else {
            this.downPopupShow = true;
            this.downloadStatus = 4;
            this.options = {
              msgIsSuccess: false,
              msgText: res.data.message
            }
          }
        })
      },
      /*
       ** 点击下载icon,展开下载选项
       */
      customDownload(item, index) {
        //审核状态不可以下载
        if (item.status > 1) {
          return
        }
        this.curDownloadIndex = index;
        this.curDownVersionId = item.version_id;
        this.downPopupShow = true;
        //脚本文件类型的判断
        if (this.sysType === '0') {
          //开始普通版下载，
          this.downloadStatus = 0;
        } else {
          // 弹出选择App的框
          this.downloadStatus = 1;
        }
      },
      /**
       * 选择下载类型后，检查打包状态
       */
      selectDownloadType (type, config) {
          const { appCode, params }  = config;
          this.versionFileDownloadConfig = config
          const app_id = this.$route.params.wid;
          const versionId = this.curDownVersionId;

          axios.get(myUrl + `packman/ee/status/${appCode}/${app_id}/${versionId}/`).then((res) => {

            if (res.data.result) {
              this.packStatus = res.data.data.status;
              //给用户返回打包状态提示
              if (this.packStatus === 2) {
                //开始下载企业版
                this.enterpriseDownload();
                this.downPopupShow = true;
                this.downloadStatus = 0;
              } else if (this.packStatus === 0 && type === 'communityCustomization' && params.user_cert_path === '') {
                this.userCertNeeded = true
              } else {
                //开始打包
                this.beginPack();
              }
            } else {
              this.downPopupShow = true;
              this.downloadStatus = 4;
            }
          })
      },
      /**
       * 取消应用下载选择
       */
      cancelDownloadSelect () {
        this.downPopupShow = false
      },
      /*
       ** 判断打包状态为2后，选择了企业版下载
       */
      enterpriseDownload() {
        const { appCode }  = this.versionFileDownloadConfig;
        const app_id = this.$route.params.wid;
        const versionId = this.curDownVersionId;

        axios.get(myUrl + `packman/ee/download/${appCode}/${app_id}/${versionId}/`).then((
          res) => {
          if (res.data.result) {
            this.fileUrl = res.data.data.url;
            window.location.href = this.fileUrl;
            this.options = {
              msgIsSuccess: true,
              msgText: res.data.message
            }
          } else {
            this.options = {
              msgIsSuccess: false,
              msgText: res.data.message
            }
          }
        })
      },
      /*
       ** 判断打包状态不为2后，选择了开始打包
       */
      beginPack() {
        const { appCode, params } = this.versionFileDownloadConfig;
        const app_id = this.$route.params.wid;
        const versionId = this.curDownVersionId;
        this.downPopupShow = true;
        this.downloadStatus = 2;
        this.packagePercent = 0

        axios.get(myUrl + `packman/ee/pack/${appCode}/${app_id}/${versionId}/`, { params }).then((res) => {
          if (res.data.result) {
            let timerId = setInterval(() => {
              this.packagePercent++;
              if (this.packagePercent > 90) {
                clearInterval(timerId)
              }
            }, 150)

            //轮询
            this.queryPackStatus(timerId)
          } else {
            //联系客服
            this.downloadStatus = 4;
          }
        })
      },
      // 打包状态查询
      // @params {Number} timerId 数字进度定时器句柄
      queryPackStatus (timerId) {
        const { appCode, params } = this.versionFileDownloadConfig;
        const app_id = this.$route.params.wid;
        const versionId = this.curDownVersionId;

        setTimeout(() => {
          axios.get(myUrl + `packman/ee/event/${appCode}/${app_id}/${versionId}/`)
            .then((res) => {
              let resData = res.data;
              if (resData.result) {
                this.packStatus = resData.data.ee_status;
                this.errorCode = resData.data.ee_code;
                if (this.packStatus === 2) {
                  this.downPopupShow = true;
                  this.downloadStatus = 0;
                  this.enterpriseDownload();
                } else if (this.packStatus === 3){
                  this.downPopupShow = true;
                  this.downloadStatus = 3;
                  clearInterval(timerId)
                } else {
                  this.queryPackStatus()
                }
              } else {
                this.downloadStatus = 4;
              }
            })
        }, 1000);
      },
      /*
       ** 文件拖动上传文件拖动上传
       */
      handleFile(e) {
        let fileInfo = e.target.files[0];
        // let maxSize = 30000; // 500kb
        let maxSize = 1024 * 1024 * 500; // 500kb
        let fileType = fileInfo.name.match(/\.(\w+)/g)[0];
        let fileName = fileInfo.name;
        let fileSize = fileInfo.size / 1024;
        this.loadingStatus = 'start';
        //判断上传的文件大小
        if (fileSize <= maxSize) {
          let fileReg = /.zip$/
          if (fileReg.test(fileName)) {
            this.formData.file = fileInfo;
            this.ableToUpload = true;
            if (this.ableToUpload) {
              // 全部判断通过后，调用文件上传接口
              let data = new FormData();
              data.append("file", fileInfo);
              data.append('file_type', 0) //定值，0为文件，1为图片
              data.append('file_name', fileName)
              data.append('file_format', 'file')

              axios.post(myUrl + 'core/product/upload/', data, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                },
              }).then((res) => {
                let resFileData = res.data;
                if (resFileData.result) {
                  this.loadingStatus = 'complete';
                  this.formData.fileId = [];
                  this.formData.fileId.push(resFileData.data);
                } else {
                  // 错误提示
                  this.options = {
                    msgIsSuccess: false,
                    msgText: res.message
                  }
                }
              }, res => {
                // 错误提示
                this.options = {
                  msgIsSuccess: false,
                  msgText: '接口异常'
                }
              })
            }
          } else {
            this.ableToUpload = false;
            this.options = {
              msgIsSuccess: false,
              msgText: '文件格式非法，只能上传zip文件！'
            }
          }
        } else {
          this.options = {
            msgIsSuccess: false,
            msgText: '该文件大小超过30MB！'
          }
        }
      },
      /*
       ** 删除某个正在上传中的文件
       */
      removeFile(item) {
        for (let [key, value] of this.fileList.entries()) {
          if (item.name && value.name === item.name) {
            this.fileList.splice(key, 1);
          }
        }
      },
      /*
       ** 删除版本
       */
      deleteVersionFile() {
        const app_id = this.$route.params.wid;
        let version_id = this.todeleteId;
        let params = {
          keyword: 'delete_version',
          version_id: version_id
        }
        axios.post(myUrl + `core/product/update/${app_id}/`, qs.stringify(params)).then((res) => {

          if (res.data.result) {
            for (let i = 0; i < this.versionList.length; i++) {
              if (this.versionList[i].version_id === version_id) {
                this.versionList.splice(i, 1)
              }
            }
            this.options = {
              msgIsSuccess: true,
              msgText: res.data.message
            }
          } else {
            this.options = {
              msgIsSuccess: false,
              msgText: res.data.message
            }
          }
        }, reject => {
          this.options = {
            msgText: res.data.message,
            msgIsSuccess: false
          }
        })
      },
      /*
       ** 调用版本文件查询接口，渲染页面
       */
      getVersionFile() {
        const app_id = this.$route.params.wid;
        let list = [];
        let onlineList = [];
        axios.get(myUrl + `core/product/info/${app_id}/`, {
          params: {
            keyword: 'version'
          }
        }).then((res) => {

          if (res.data.result) {
            let resquest = res.data.data;
            this.isLoading = false;
            this.isNullData = false;
            let resData = resquest.app_version;
            this.appName = resquest.app_name;
            this.sysType = resquest.sys_type;

            // let tempArr = [];
            // for (var i = 0; i < resData.length; i++) {
            //   if (resData[i].status === 0) {
            //     onlineList.push(resData[i])
            //   }
            // }
            this.versionList = resData;
            //只有正常状态才能更换线上版本
            let newList = [];
            for (let key in this.versionList) {
              if (this.versionList[key].status === 1) {
                newList.push(this.versionList[key])
              }
            }
            this.changeVersionList = newList;
            //只有正常状态的第一个才能有new标志
            let tempList = [];
            for (let key in this.versionList) {
              if (this.versionList[key].status === 1 || this.versionList[key].status === 0) {
                tempList.push(this.versionList[key])
              }
            }
            if (tempList[0]) {
              this.versionWithNew = tempList[0].version_id;
            }
            console.log(this.versionWithNew)

          } else {
            console.log(res.data.message)
          }
        })
      },
      /*
       ** 调用App查询接口，渲染页面
       */
      getAppList() {
        axios.get(myUrl + `packman/ee/list/`).then((res) => {

          let resData = res.data;
          if (resData.result) {
            this.appList = resData.data;

          } else {
            console.log("调用App接口有误");
          }
        })
      },
      /*
       ** 添加新的版本，点击“保存”
       */
      saveUpdate() {
        this.saveFlag = false;
        setTimeout(() => {
          this.saveFlag = true
        }, 2000)
        if (!this.checkValidate()) {
          return true;
        } else {
          let isEmpty = true;
          let params = {
            keyword: "new_version",
            version: this.formData.version,
            changelog: this.formData.updataMsg,
            files: JSON.stringify(this.formData.fileId)
          }
          if (this.formData.version && this.formData.updataMsg && this.formData.fileId) {
            isEmpty = false;
          }
          if (isEmpty) {
            window.scrollTo(0, 0);
            this.options = {
              msgText: "输入不能为空！",
              msgIsSuccess: false
            }
            return
          } else {
            let app_id = this.$route.params.wid;
            axios.post(myUrl + `core/product/update/${app_id}/`, qs.stringify(params)).then((res) => {

              if (res.data.result) {
                this.saveFlag = true;
                this.isUpdate = false;
                this.getVersionFile()
                this.formData.version = '';
                this.formData.file = {};
                this.formData.tips = '';
                this.formData.updataMsg = '';
                this.ableToUpload = false;
                this.options = {
                  msgIsSuccess: true,
                  msgText: res.data.message
                }

              }
            }, reject => {
              this.options = {
                msgText: res.data.message,
                msgIsSuccess: false
              }
            })
          }
        }
      }
    },
    mounted() {
    
      document.addEventListener('click', this.handleDocumentClick);
    },
    created() {
      this.getVersionFile();
      this.getAppList();
    },
    components: {
      popup,
      change_version,
      versionFileDownload,
      vAlert,
      loading
    }
  }
</script>

<style media="screen" lang="scss">
  .version-file {
    .isSelect {
      .s-popup-wrapper {
        height: 200px !important;
      }
    }
    .public {
      .loading-box {
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translate(-50%, -50%);
        .loading {
          width: 4px;
          height: 80px;
          position: relative;
          margin: 20px auto;
          .strip {
            width: 100%;
            height: 60%;
            position: absolute;
            &::before {
              content: '';
              display: block;
              margin: 0 auto;
              width: 100%;
              height: 24%;
              background-color: #000;
              border-radius: 6px 6px 0 0;
              animation: stripFadeDelay 1.2s infinite ease-in-out both;
            }
          }
          .strip2 {
            transform: rotate(30deg);
          }
          .strip3 {
            transform: rotate(60deg);
          }
          .strip4 {
            transform: rotate(90deg);
          }
          .strip5 {
            transform: rotate(120deg);
          }
          .strip6 {
            transform: rotate(150deg);
          }
          .strip7 {
            transform: rotate(180deg);
          }
          .strip8 {
            transform: rotate(210deg);
          }
          .strip9 {
            transform: rotate(240deg);
          }
          .strip10 {
            transform: rotate(270deg);
          }
          .strip11 {
            transform: rotate(300deg);
          }
          .strip12 {
            transform: rotate(330deg);
          }
          .strip2:before {
            animation-delay: -1.1s;
          }
          .strip3:before {
            animation-delay: -1s;
          }
          .strip4:before {
            animation-delay: -0.9s;
          }
          .strip5:before {
            animation-delay: -0.8s;
          }
          .strip6:before {
            animation-delay: -0.7s;
          }
          .strip7:before {
            animation-delay: -0.6s;
          }
          .strip8:before {
            animation-delay: -0.5s;
          }
          .strip9:before {
            animation-delay: -0.4s;
          }
          .strip10:before {
            animation-delay: -0.3s;
          }
          .strip11:before {
            animation-delay: -0.2s;
          }
          .strip12:before {
            animation-delay: -0.1s;
          }
          @-webkit-keyframes stripFadeDelay {
            0%,
            39%,
            100% {
              opacity: 0.5;
            }
            40% {
              opacity: 1;
            }
          }

          @keyframes stripFadeDelay {
            0%,
            39%,
            100% {
              opacity: 0.5;
            }
            40% {
              opacity: 1;
            }
          }
        }
      }
      .public-content {
        margin-top: 50px;
        text-align: center;
        &.consult {
          .tips {
            margin-top: 0;
          }
        }
        .round {
          width: 110px;
          height: 110px;
          line-height: 110px;
          border-radius: 50%;
          background: #fafafa;
          text-align: center;
          font-size: 42px;
          margin: 0 auto;
          color: #888888;
          &.tempo {
            font-size: 16px;
            background: #fff;
            border: none;
            color: #4f515e;
            .number {
              font-size: 60px;
            }
          }
        }
        .phone {
          font-size: 20px;
          color: #4f515e;
          font-weight: bold;
        }
        .tips {
          line-height: 30px;
          margin-top: 18px;
          color: #888;
        }
        .confirm-button {
          display: inline-block;
          width: 254px;
          height: 52px;
          line-height: 52px;
          text-align: center;
          background: #57a3f1;
          border-radius: 3px;
          color: #ffffff;
          font-size: 16px;
          &:hover {
            background: #4491e1;
          }
          &.disabled {
            background: #98c6f5;
          }
          &.service {
            border: 1px solid #d6d6d6;
            color: #444444;
            /* &:hover {
              background: #fafafa;
            } */
          }
          &.againPack {
            border: 1px solid #d6d6d6;
            color: #444444;
            background: #fafafa;
          }
        }
        &.warning {
          .round {
            background: #ff7979;
            color: #fff;
          }
          .tips {
            color: #d75a4a;
          }
        }
      }
    }
  }

  .attention {
    .bk-icon {

      display: inline-block;
      &.icon-angle-down {
        cursor: pointer;
      }
      &.icon-download,
      &.icon-delete {
        position: relative;
        font-size: 14px;
        padding: 8px;
        cursor: pointer;
        border-radius: 2px;

      }
      &.icon-checking {
        position: relative;
        font-size: 14px;
        color: #elele3;
        padding: 8px;
        border-radius: 2px;
        cursor: default;
      }

      &.icon-checking {
        color: #e1e1e3 !important;
        &:hover {
          background-color: #ffffff !important;
        }




      }
      &.icon-active {
        color: #e1e1e3 !important;
        &:hover {
          background-color: #ffffff !important;
        }


      }
      &.icon-download {
        &:hover {
          background: #57a3f1;
          color: #ffffff;
        }
      }
      &.icon-delete {
        &:hover {
          background-color: #ff5656;
          color: #ffffff;
        }
      }
    }
    .bk-button {
      .bk-icon+span {
        margin-left: 2px;
      }
    }
  }

  .loading {
    margin-top: 200px;
  }

  .upload-search-null {
    width: 831px;
    height: 83px;
    margin: 135px 0;
    text-align: center;
    color: #878996;
    font-size: 16px;
    p {
      margin-top: 25px;
    }
    span {
      color: #ff6600;
    }
  }
</style>

<style media="screen" lang="scss" scoped>
  .attention {
    min-height: 650px;
    padding: 27px 40px;
    display: table;
  }

  .online {
    padding: 0 40px 40px 40px;
    border-bottom: 10px solid #f4f4f4;
    display: table;
    h4 {
      padding: 20px 0;
      font-size: 18px;
      font-weight: bold;
      color: #77787f;
      border-bottom: 1px solid #f4f4f4;
    }
  }

  .icon-file-zip {
    width: 30px;
    height: 30px;
    background: url(../../../images/application_detail/icon-file-zip.png) no-repeat;
    margin-right: 10px;
    top: -10px;
  }

  .bk-icon {
    position: relative;

    .tips {
      position: absolute;
      top: -38px;
      left: 50%;
      -webkit-transform: translateX(-50%);
      transform: translateX(-50%);
      display: none;
      font-size: 12px;
      color: #ffffff;
      line-height: 30px;
      padding: 0 10px;
      background: rgba(0, 0, 0, 0.8);
      border-radius: 2px;
      font-style: normal;
      white-space: nowrap;

      &:after {
        content: '';
        position: absolute;
        left: 50%;
        bottom: -12px;
        width: 0;
        height: 0;
        border: 6px solid rgba(0, 0, 0, 0.8);
        border-color: rgba(0, 0, 0, 0.8) transparent transparent transparent;
        margin-left: -6px;
      }
      &:hover {
        .tips {
          font-family: 'pingFang-SC-Regular', '微软雅黑', Arial;
          display: inline-block;
        }
      }
    }
    .version {
      position: absolute;
      left: 23% !important;
      top: -40px;
    }

    .icon-check-1 {
      position: absolute;
      left: 1px;
      top: 1px;
    }
  }

  .download-box {
    position: absolute;
    top: 32px;
    right: 0;
    border: 1px solid #e6e6e6;
    background: #ffffff;
    z-index: 100;
    text-align: left;
    color: #737987;
    .download-content {
      width: 100%;
      display: inline-block;
      padding: 0 15px;
      line-height: 40px;
      background: #ffffff;
      white-space: nowrap;
      font-style: normal;
      &:hover {
        background: #ebf4ff;
        color: #57a3f1;
      }
    }
  }

  .icon-file-loading {
    width: 12px;
    height: 12px;
    position: relative;
    top: 0;
    left: 2px;
    background: url(../../../images/application_detail/icon-file-loading.png) center bottom no-repeat;
  }

  .icon-file-loaded {
    width: 16px;
    height: 12px;
    position: relative;
    top: 0;
    background: url(../../../images/application_detail/icon-file-loaded.png) center bottom no-repeat;
  }

  .bk-table {
    margin-top: 20px;
    width: 100%;
    float: left;
    .bk-table-tr {
      background: #fafafa;
    }
    .bk-table-list {
      display: inline-block;
      padding: 20px 20px 20px 30px;
      &.left {
        width: 434px;
        border-right: solid 1px #e6e6e6;
        float: left;
      }
      &.right {
        width: 396px;
        border-left: solid 1px #e6e6e6;
        margin-left: -1px;
      }
      .icon-file-download,
      .icon-file-loading,
      .icon-file-loaded {
        margin-left: 30px;
      }
      p {
        line-height: 20px;
        padding: 5px 0;
      }
      .bk-list-title {
        color: #4f515e;
        font-weight: bold;
        padding-bottom: 10px;
      }
      .bk-list-title-para {
        word-break: normal;
        white-space: pre-line;
      }

    }
  }

  .bk-table>tbody>tr>td {
    font-size: 14px;
    height: 46px;
    line-height: 20px;
    display: table-cell;
    vertical-align: middle;
    padding: 0 10px 0 20px;
    position: relative;
    &:nth-child(4),
    &:nth-child(5),
    &:nth-child(6) {
      padding: 0;
      text-align: center;
    }
    &.last {
      &.gruy,
      &:hover {
        background: #fafafa;
      }
    }
    .downloadbox {
      display: table;
      margin: 0 auto;
    }
    span.status {
      display: inline-block;
      position: relative;
      top: 4px;
      width: 85px;
      height: 24px;
      border-radius: 5px;
      overflow: hidden;
      text-align: center;
      line-height: 22px;
      &.default {
        color: #ffffff;
        background: #5bd18b;
        border: solid 1px #5bd18b;
      }
      &.danger {
        color: #ffffff;
        background: #ff5656;
        border: solid 1px #ff5656;
      }
      &.fail {
        color: #ff5656;
        background: #fafafa;
        border: solid 1px #f4f4f4;
      }
      &.info {
        color: #ffffff;
        background: #57a3f1;
        border: solid 1px #57a3f1;
      }
      &.onlineIcon {
        color: #57a3f1;
        >i {
          margin-right: 3px;
        }
      }
    }
    span.new {
      display: inline-block;
      color: #ffffff;
      font-size: 12px;
      line-height: 14px;
      padding: 0 3px;
      background: #ff6600;
      border-radius: 2px;
      margin-left: -2px;
      transform: scale(0.8);
    }
    a.bk-text-button {
      color: #3c96ff;
      padding: 0 12px;
      &:hover {
        color: #5c90d2
      }
    }
    span.bk-text-button {
      padding-right: 22px;
    }
  }

  .bk-list-li {
    height: 50px;
    padding: 10px 0;
    .bk-list-content {
      position: relative;
      width: 313px;
      overflow: hidden;
      display: inline-block;
      span {
        display: inline-block;
        line-height: 30px;
      }
      .name {
        width: 200px;
        margin-right: 10px;
        float: left;
        height: 40px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .capacity {
        width: 70px;
      }
    }
    .bk-load {
      position: absolute;
      bottom: 0;
      width: 100%;
      left: 0;
      height: 3px;
      background: #e6e6e7;
      display: inline-block;
      .loading {
        display: inline-block;
        position: absolute;
        bottom: 0;
        left: 0;
        height: 3px;
        background: #57a3f1;
        width: 10%;
      }
    }
  }

  .bk-upload-ul {
    margin-right: -10px;
    /* padding-left: 126px; */
    margin-bottom: -10px;
    .bk-list-li {
      height: 58px;
      border: 1px solid #e6e6e7;
      padding: 14px 10px;
      margin-right: 10px;
      margin-bottom: 10px;
      width: calc(50% - 10px);
      display: inline-block;
      .bk-list-content {
        vertical-align: top;
        top: -10px;
        width: calc(100% - 50px);
        .name {
          width: 100%;
        }
        span {
          line-height: 40px;
          color: #888991;
        }
        .icon-close {
          position: absolute;
          right: 0;
          cursor: pointer;
          top: 13px;
          left: auto;
        }
      }
    }
  }

  .bk-button {
    width: 117px !important;
    margin-bottom: 10px !important;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: height .5s;
  }

  .fade-enter,
  .fade-leave-to {
    height: 0;
  }

  .bk-form {
    display: table;
    &.form-version {
      margin: 20px 0 0 0;
      width: 100%;
      float: left;
      .bk-form-textarea {
        min-height: 120px;
        display: inline-block;
        &.bk-form-upload {
          position: relative;
          height: 60px;
          min-height: 60px;
          background: #fafafa;
          border: 1px dashed #e6e6e6;
          color: #a6a6a6;
          text-align: center;
          line-height: 40px;
          -webkit-transition: all .5s;
          transition: all .5s;
          cursor: pointer;
          a {
            color: #3c96ff;
          }
          &:hover {
            box-shadow: 0 1px 2px rgba(0, 0, 0, .1);
            a {
              color: #5c90d2;
            }
          }
        }
      }
      .upload-file {
        cursor: pointer;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
      }
      .tips {
        background: #090b1a;
        position: absolute;
        white-space: nowrap;
        color: #fff;
        top: -40px;
        left: 50%;
        padding: 0 10px;
        height: 30px;
        line-height: 30px;
        border-radius: 2px;
        text-align: center;
        transform: translateX(-50%);
        -o-transform: translateX(-50%);
        -ms-transform: translateX(-50%);
        -moz-transform: translateX(-50%);
        -webkit-transform: translateX(-50%);
        &.version {
          position: absolute;
          left: 23%;
          top: -40px;
        }
        &:after {
          content: '';
          position: absolute;
          left: 50%;
          bottom: -14px;
          width: 0;
          height: 0;
          border: 10px solid #090b1a;
          border-color: #090b1a transparent transparent transparent;
          margin-left: -10px;
        }

      }

    }
    .icon-upload {
      position: relative;
      top: 2px;
      margin-right: 10px;
      /* width: 18px;
      height: 17px;
      margin-right: 10px;
      background: url(../../../images/application_detail/icon-upload2.png) no-repeat; */
    }
    .bk-form-action {
      margin-top: 30px;
    }
    .bk-button {
      float: left;
      margin-right: 10px;
    }
    .bk-form-item {
      &:nth-child(3) {
        .bk-list-content {
          .bk-icon.icon-check-1 {
            position: absolute;
            left: 260px;
            top: 15px;
            color: #5bd18b;
          }
        }
      }
    }

  }

  .pop-wrapper {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .3);
    z-index: 1111;
    .pop-box {
      width: 400px;
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      padding: 20px;
      border-radius: 3px;
      .pop-header {
        margin-bottom: 10px;
      }
      .pop-body {
        text-align: center;
        font-size: 22px;
        color: #333;
        width: 100%;
      }
      .pop-footer {
        padding: 20px 45px 20px;
        text-align: center;
        font-size: 0;
        .yes,
        .no {
          font-size: 16px;
          height: 36px;
          line-height: 36px;
          border-radius: 3px;
          display: inline-block;
          width: 110px;
        }
        .yes {
          color: #fff;
          background: #57a3f1;
          margin-right: 20px;
        }
        .no {
          color: #666;
          border: 1px solid #e5e5e5;
        }
      }
    }
  }

  .isSelect {
    .s-popup-wrapper {
      height: 200px !important;
    }
  }
</style>


// WEBPACK FOOTER //
// version_file.vue?1f39cca9